<template>
  <div>
    <div>

      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">基础信息</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">生产基础数据维护</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">包装方式维护</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>
      <div class="layout-content">
        <div class="layout-content-main">
          <div class="method-wrapper">
            <div style="display:inline-block;" >
             <template>
                <Input v-model="searchResult" placeholder="包装方式名称" style="width: 300px"></Input>
            </template>
              <Button type="ghost" class="mRight mLeft" @click="this.getResearch">查询</Button>
            </div>
            <Button type="primary" class="mRight" @click="this.addPack">新增</Button>
            <Button type="primary" class="mRight" @click="this.editPackstyle">修改</Button>
            <Button type="primary" class="mRight" @click="this.deleteData">删除</Button>   
          </div>
          <div class="clearfix"></div>
          <div class="table-wrapper">
            <!-- <Table  border :columns="columns4" :data="nodes"></Table> -->
            <Table style="min-width: 700px" border 
            :columns="columns" 
            :data="pageData.data" 
            @on-selection-change="getSelected"
            >

            </Table >
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <!-- <Page :total="this.total" :current="1" @on-change="changePage"></Page> -->
                     <Page :total="pageData.page.totalCount" @on-change="onChange"  show-sizer show-elevator show-total  @on-page-size-change="sizeChange"></Page>
                </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-----弹层------>
    <Modal
        v-model="addModal"
        :mask-closable="false"
    >
      <p slot="header" style="text-align:center">
        <Icon type="information-circled"></Icon>
        <span>{{modelName}}</span>
      </p> 
      <Form :model="packItem" ref="packItem" :label-width="100" :rules="ruleValidate">
        <!-- <FormItem label="包装方式代码" prop="code">
            <Input v-model="packItem.code"></Input>
        </FormItem> -->
        <FormItem label="包装方式名称" prop="name">
            <Input v-model="packItem.name"></Input>
        </FormItem>
        <FormItem label="包装费用" prop="fee">
            <Input  v-model="packItem.fee"></Input>
        </FormItem>
        <FormItem label="包装方式描述" prop="desc">
            <Input v-model="packItem.desc"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="handleSubmit('packItem')" long >确定</Button>
      </div>
    </Modal>
  
  
  </div>
</template>
<style scoped lang="scss">
 
</style>
<script>
  import api from '../../api/apinew'
  import axios from 'axios'
  import Qs from 'qs'
import { clearTimeout } from 'timers';

  export default{
    data(){
        const validaFee = (rule, value, callback) =>{
            if(value == ''){
                callback(new Error('请输入包装费用！'));
            }
            // 模拟异步验证效果
                setTimeout(() => {
                    if (value == '') {
                        callback(new Error('费用不能为空'));
                    } else {
                        if (!/^[0-9]*$/.test(value)) {
                            callback(new Error('请输入数字'));
                        } else {
                            callback();
                        }
                    }
                }, 100);
        };
      return {
        modelName:'新增包装方式',
        searchResult:'',
        packItem:{
            code:'',
            name:'',
            fee:0,
            desc:'',
            id:'',
            segNo:''
        },
        addModal:false,
        columns: [
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {   
                title: '包装方式代码',
                key:'packingTypeId',
                align: 'center'
            },
            {
                title: '包装方式名称',
                key: 'packingTypeName',
                align: 'center'
            },
          
            {
                title: '包装费用',
                key: 'packingFee',
                align: 'center'
            },
            {
                title: '包装方式描述',
                key: 'packingTypeDesc',
                align: 'center'
            },
           
        ],
        pageData:{  
           data:[],  
           page:{  
              //分页数  
               // arrPageSize:[10,20,30,40],  
               //分页大小  
               pagesize:10,  
               //总分页数  
               pageCount:1,  
               //当前页面  
               pageCurrent:1,  
               //总数  
               totalCount:0  
           }  
        },
         ruleValidate:{
            code:[
                {required:true,message:'包装代码方式不能为空！',trigger:'blur'}
            ],
            name:[
                {required:true,message:'包装代码名称不能为空！',trigger:'blur'}
            ],
            fee:[
                {required:true,validator:validaFee,trigger:'blur'},
                // {validator(rule, value, callback) {
                //   //var errors = [];
                //   if(!/^[0-9]*$/.test(value)) {
                //     callback('请输入数字');
                //     }
                //     //callback(errors);
                // }}
            ],
            desc:[
                {required:true,message:'包装描述不能为空！',trigger:'blur'}
            ]
        },
        selectedData:{},
        listSelected:{},
        disabled:false,
      }
    },
    mounted:function(){  
     this.listData(this.pageData.page.pageCurrent,this.pageData.page.pagesize);
      
      
       
    },
    methods: {
        //列表获取
        listData:function(pageCurrent,pagesize){
            api.packType.getList({
               'page': pageCurrent,
               'limit':pagesize
            },response =>{
                if(response.msg == 'success'){
                   console.log(response)
                    this.pageData.data = response.page.list;
                    this.pageData.page.totalCount = response.page.totalCount;
                }else{
                    this.$Message.error(response.msg);
                }
            });
        },
        //搜索
        getResearch:function(){
            
               api.packType.getList({
                    'page':this.pageData.page.pageCurrent,
                    'limit':this.pageData.page.pagesize,
                    'packingTypeName':this.searchResult,
                }, resp => {
                    if(resp.code == 0){
                        this.pageData.data = resp.page.list;
                    // 获取分页总条数
                    this.pageData.page.totalCount = resp.page.totalCount;
                    //this.searchResult = '';
                    }
                   
                }, error => {
                  this.$Message.error('请求失败');
                })

            

        },
        // 分页 -- 页数改变
        onChange:function(curpage){  
            // alert("当前页面页码是：" + curpage);
            this.pageData.page.pageCurrent = curpage;
            this.listData(this.pageData.page.pageCurrent,this.pageData.page.pagesize);
        },
        // 分页 -- pageSize 改变
        sizeChange:function(size){
         // alert("当前页面size是：" + size);
          this.pageData.page.pagesize = size;
          this.listData(this.pageData.page.pageCurrent,this.pageData.page.pagesize);
        },
        //弹层
        addPack:function(){
            this.modelName = '新增包装方式';
            this.packItem ={};//初始化新增方式
            this.addModal = true ;
        },
        editPackstyle:function(){
                if(this.selectedData.length == 0 || this.selectedData.length == undefined){
                    this.$Message.error('请至少选择一条记录!');
                    return;
                    }
                else if(this.selectedData.length>1){
                    this.$Message.error('只能选中一条数据进行修改!');
                    return;
                }else{
                    this.modelName = '修改包装方式';
                    this.addModal = true ;
                    this.packItem = {
                       code : this.selectedData[0].packingTypeId,
                       name : this.selectedData[0].packingTypeName,
                       fee  : this.selectedData[0].packingFee,
                       desc : this.selectedData[0].packingTypeDesc,
                        id: this.selectedData[0].id,
                        segNo:this.selectedData[0].segNo,
                    }  
                }
        },
        editData:function(){
            api.packType.editPack({
              packingTypeId:this.packItem.code,//后台传
              packingTypeName:this.packItem.name,
              packingFee:this.packItem.fee,
              packingTypeDesc:this.packItem.desc,
              id:  this.packItem.id,
              segNo:this.packItem.segNo
            },res =>{
                console.log(res)
                if(res.code == 0){
                    this.$Message.success('修改成功!'); 
                    this.addModal = false; 
                    this.disabled = true;
                    this.listData(this.pageData.page.pageCurrent,this.pageData.page.pagesize);
                }else{
                   this.$Message.error('修改失败!'); 
                    this.disabled = false;
                    return;  
                }
            });
        },
        handleSubmit:function(name){
            this.$refs[name].validate((valid) =>{
                valid = true;
            if(valid){
                if(this.modelName == '新增包装方式'){
                    console.log(this.packItem.code);
                        api.packType.addPack({
                            //packingTypeId:this.packItem.code,
                            packingTypeName:this.packItem.name,
                            packingFee:this.packItem.fee,
                            packingTypeDesc:this.packItem.desc
                        },response=>{
                            console.log(response)
                            if(response.msg =='success'){
                            this.$Message.success('新增成功!'); 
                            this.addModal = false; 
                            this.disabled = true;
                            this.listData(this.pageData.page.pageCurrent,this.pageData.page.pagesize);
                            }else{
                            this.$Message.error('新增失败!'); 
                            this.disabled = false;
                            return; 
                            }
                        })
                }else if(this.modelName == '修改包装方式'){
                    this.editData();   
                }
            }else{
                    this.$Message.error('Fail!');
                }
            });
        },
    //删除
        deleteData:function(){
            var id =[];
            if(this.selectedData.length == 0 || this.selectedData.length == undefined){
                this.$Message.error('请至少选择一条记录!');
                return;
            }else{
                console.log(this.selectedData);
                for(var i=0 ;i < this.selectedData.length; i++){
                  id.push(this.selectedData[i].id);
                }
                this.del(id);
            } 
        },
        del:function(id){
            api.packType.delPack(id,response=>{
              if(response.msg == 'success'){
                this.$Message.success('删除成功!'); 
                this.listData(this.pageData.page.pageCurrent,this.pageData.page.pagesize);
              }else{
                this.$Message.error(response.msg); 
              }
            })
        },
    //选中
        getSelected:function(ele){
           this.selectedData = ele;
           console.log(ele)
        }
    },
      
    }
</script>



// WEBPACK FOOTER //
// calendar.vue?441caed2